<template>
  <div id="tab">
    <ul class="tabContain" @click="handleClick" >
      <li class="tabItem" v-for="(item,index) in itemList" :key="index" :pathname="item.link" @mouseenter="handleOver(item.id)" @mouseleave="handleLeave(item.id)">
        <router-link :to="item.link||''" class="itemTitle" :code="item.code" v-show="item.link" >
          {{item.name}}
          <span class="icon" v-show="item.children ">
            <img src="../../assets/images/arrow_03.png" alt="" width="15px">
          </span>
        </router-link>
        <span class="itemTitle noLink" :code="item.code" v-show="item.link === ''">
          {{item.name}}
          <span class="icon" v-show="item.children ">
            <img src="../../assets/images/arrow_03.png" alt="" width="15px">
          </span>
        </span>
        <ul class="item-child-one" v-if="item.children" :id="item.id">
          <li class="childItem" v-for="(n,i) in item.children" :key="i" :code="n.code">
            <router-link :to="n.link || ''" class="childItemTile" :code="n.code">
              {{n.name}}
            </router-link>
            <!-- <span></span> -->
            <!-- <ul class="item-chilren-two" v-show="n.grandchildren">
              <li class="childItem" v-for="(m,k) in n.grandchildren" :key="k" :code="m.code">
                <router-link :to="m.link || ''" class="itemTitle" :code="m.code">{{m.name}}</router-link>
              </li>
            </ul> -->

          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props:{
    itemList:Array
  },
  data(){
    return {
    }
  },
  methods:{
    handleClick(event){
      let e = event || window.event
      let code = e.target.getAttribute('code');
      let pathname = e.target.parentNode.parentNode.parentNode.getAttribute('pathname')
      if(e.target.parentNode.parentNode.id && e.target.nodeName.toLowerCase() !== 'ul' ){
        e.target.parentNode.parentNode.style.display = 'none'
      }
      if(pathname === '' || !pathname || !code)return;
      this.$emit('click',code,pathname)
    },
    handleOver(id){
      if(id){
        document.querySelector('#'+id).style.display = 'block'
      }
    },
    handleLeave(id) {
      if(id){
        document.querySelector('#'+id).style.display = 'none'
      }
    }
  },
  mounted(){
  }
}
</script>

<style lang="less">
  #tab{
    --h:60px;
    width: 100%;
    background-color: #729bf0;
    .tabContain{
      display: flex;
      justify-content: space-between;
      // height: var(--h);
      height: 60px;
      margin: 0 auto;
      width: 1200px;
      .tabItem{
        >a{
          // padding-left: 45px;
          padding: 0 30px;
          display: block;
          line-height: 60px;
          &.router-link-exact-active{
            background-color: #6d7bec;
            color: #fff;
          }
        }
        .noLink{
          cursor: pointer;
          padding: 0 20px;
          display: block;
          line-height: 60px;
        }
        .icon{
            width: 20px;
            height: 20px;
            display: block;
            float: right;
            img{
              vertical-align: middle;
              margin-left: 5px;
            }
          }
        height: inherit;
        // line-height: var(--h);
        display: block;
        position: relative;
        float: left;
        display: flex;
        align-items: center;
      }
      .tabItem:hover{
        background-color: #6d7bec;
        .item-child-one{
          // display: block;
          // z-index: 99;
        }
      }
      .itemTitle{
        color: #fff;
        font-size: 16px;
      }
      .item-child-one{
        background-color: #fff;
        z-index: 999;
        cursor: pointer;
        padding: 12px 0;
        width: 300px;
        display: none;
        position: absolute;
        left: 0;
        top: 60px;
        line-height: 30px;
        box-shadow: 0px 2px 5px 1px #c9c9c9;
        .childItem{
          font-size: 14px;
          position: relative;
        }
      }
      .childItemTile{
        padding-left: 47px;
        color: #333;
        display:block;
      }
      .childItem:hover{
        background-color: #eaeaea;
        a{
          color: #729bf0;
        }
        .item-chilren-two{
          display: block;
        }
      }
      .item-chilren-two{
        cursor: pointer;
        position: absolute;
        right: 0;
        transform: translateX(100%);
        // width: 150px;
        top: 0;
        display: none;
        box-shadow: 0px 2px 5px 1px #c9c9c9;
        .childItem{
          // width: 50px;
          padding:0 50px;
          // text-indent: 47px;
          a{
            color: #333
          }
        }
        .childItem:hover{
          a{
            color: #729bf0
          }
        }
      }
    }
    .isnone{
      display: none ;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tab/Tab.vue